export function QpuiNumberRegularDirective(): ng.IDirective {
    return {
        require: ["^ngModel", "^qpuiNumberRegular"],
        controller: [function () {
            let self = this;

            self.isNumberKey = function (keyCode: number): boolean {
                 // numbers(0~9)keycode: 48~57, numpad number(0~9) keycode: 96~105
                if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
                    return true;
                }
                return false;
            }

            /**
             * @ngdoc function
             * @name saveProductInstanceCallback
             * 數字類型處理
             */
            function numberInputRegular(scope, element, attrs, e) {
                var keyCode = e.keyCode || e.which;
                var checkValue = false;

                //通用按键，回退、Tab等，請參照https://css-tricks.com/snippets/javascript/javascript-keycodes/
                //backspace、tab、enter、shift、ctrl、alt、caps_lock、esc、left _arrow、right_arrow、del、num_lock
                //keycode 144 为num_lock键
                if ([8, 9, 13, 16, 17, 18, 20, 27, 37, 39, 46, 136, 144].indexOf(keyCode) != -1) {
                    checkValue = true;
                }

                //負數處理
                if (!checkValue && attrs.allowNegative != "false") {
                    if (keyCode == 109 || keyCode == 189) {
                        checkValue = true;
                    }
                }

                //小數處理
                if (!checkValue && attrs.allowDecimal != "false") {
                    if (keyCode == 110 || keyCode == 190) {
                        checkValue = true;
                    }
                }

                //數字按鈕
                if (!checkValue) {
                    if (self.isNumberKey(keyCode)) {
                        checkValue = true;
                    }
                }

                // backspace或delete键后，值小于1处理
                if (checkValue && (keyCode == 8 || keyCode == 46)) {
                    checkValue = true;
                    let currentValue = parseFloat(self.ngModelCtrl.$viewValue);
                    // 当前值为小数处理
                    if (Math.floor(currentValue) !== currentValue) {
                        if (self.ngModelCtrl.$viewValue.length == 2 && self.ngModelCtrl.$viewValue[0] == 0) {
                            self.ngModelCtrl.$setViewValue(1);
                            checkValue = false;
                        }
                    } else {
                        // 个位数处理
                        if (currentValue / 10 < 1) {
                            self.ngModelCtrl.$setViewValue(1);
                            checkValue = false;
                        }
                    }
                }

                // 精确度
                if (attrs.allowDecimal == "true") {
                    let pointIndex = String(self.ngModelCtrl.$viewValue).indexOf(".");
                    if (pointIndex > -1 && (pointIndex + Number(attrs.decimalPrecision) == self.ngModelCtrl.$viewValue.length - 1)) {
                        if (self.isNumberKey(keyCode)) {
                            e.preventDefault();
                        } 
                    }
                }

                //處理結果，沒有通過的，拒絕輸入
                if (checkValue) {
                    /** @param {*} arg(scope) */
                    scope.$apply(function (arg) {
                        scope.$eval();
                    });
                } else {
                    e.preventDefault();
                }
            };

            /**
             * 檢查文本
             * @param {type} attrs
             * @param {type} text
             * @returns
             */
            function validateNumberValue(attrs, text) {
                var regRule = "^";

                //負數校驗
                if (attrs.allowNegative != "false") {
                    regRule += "(-)?";
                }

                //整數部份
                regRule += "(\\d)+";

                //小數部份
                if (attrs.allowDecimal != "false") {
                    var n = attrs.decimalPrecision;
                    if (n) {
                        regRule += "(.\\d{1," + n + "})*";
                    }
                    else {
                        regRule += "(.\\d)*";
                    }
                }

                //結束
                regRule += "$";

                var reg = new RegExp(regRule);
                return reg.test(text);
            };

            self.acceptTypes = {
                /**
                 * 數字類型，輸入事件
                 */
                number: numberInputRegular,
                /**
                * Value驗證方法
                */
                numberValidate: validateNumberValue
            };
        }],
        link: (scope, element, attrs, ctrls) => {
            let ngModelCtrl = ctrls ? ctrls[0] : null;
            let selfCtrl = ctrls ? ctrls[1] : null;

            if (!ngModelCtrl) {
                return;
            }

            selfCtrl.ngModelCtrl = ngModelCtrl;

            // element.on("keypress", (event) => {
            //     selfCtrl.acceptTypes[attrs.qpuiNumberRegular](scope, element, attrs, event);
            // })
            element.on("paste", (event) => {
                selfCtrl.acceptTypes[attrs.qpuiNumberRegular](scope, element, attrs, event);
            })
            element.on("keydown", (event) => {
                // selfCtrl.acceptTypes.numberInputRegularKeydown(scope, element, attrs, event);
                selfCtrl.acceptTypes[attrs.qpuiNumberRegular](scope, element, attrs, event);
            })

        }
    }
}